import { create } from 'zustand'

export enum DialogType {
	SESSION_EXPIRED = 'sessionExpired'
}

export interface DialogsState {
	isVisible: boolean
	dialogType: DialogType | null
	props?: Record<string, unknown>
	showDialog: (dialogType: DialogType, props?: Record<string, unknown>) => void
	hideDialog: () => void
}

export const useDialogsStore = create<DialogsState>(set => ({
	isVisible: false,
	dialogType: null,
	props: undefined,
	showDialog: (dialogType: DialogType, props?: Record<string, unknown>) =>
		set({
			isVisible: true,
			dialogType,
			props
		}),
	hideDialog: () =>
		set({
			isVisible: false,
			dialogType: null,
			props: undefined
		})
}))
